export function formatDate(dateString) {
  const date = new Date(dateString);
  // Then specify how you want your dates to be formatted
  return new Intl.DateTimeFormat('default', { dateStyle: 'long', timeStyle: 'short' }).format(date);
};

// convert to March 20, 2024 with comma
export function formatDateLong(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('default', { day: 'numeric', month: 'long', year: 'numeric' });
}

// convert to 20/03/2024 with no comma
export function formatDateWithOutTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('default', { day: 'numeric', month: 'numeric', year: 'numeric' });
}

// convert to 20 MAR 2024 with no comma
export function formatDateShort(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('default', { day: 'numeric', month: 'short', year: 'numeric' });
}

// Figma date format e.g. September 12th, 2023 @ 9:32 AM
export function formatDateWithTime(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('default', { day: 'numeric', month: 'long', year: 'numeric' })} @ ${date.toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
}

// Figma 31/08/24 15:21
export function formatDateWithTimeShort(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('default', { day: 'numeric', month: 'numeric', year: '2-digit' })} ${date.toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric' })}`;
}

// convert to 20 MAR with no comma and no year
export function formatDateShortWithoutYear(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('default', { day: 'numeric', month: 'short'});
}

// Figma date format e.g. September 12th, 2023 @ 9:32:01 AM
export function formatDateWithTimeSecond(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('default', { day: 'numeric', month: 'long', year: 'numeric' })} @ ${date.toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })}`;
}

// Relative time for recent notifications; falls back to formatDateLong for anything over a week old.
// Intentionally computed client-side (it's UX, not a stored value) so the "X minutes ago" text stays fresh without refetching.
export function timeAgo(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return 'Just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  return formatDateLong(dateString);
}

// regex date only "2026-10-06" to date object midnight local
export function parseDateOnly(value) {
  if (!value) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value).trim());
  if (!match) return null;

  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

// "2026-10-06" to "October 6, 2026" in user locale
export function formatDateOnlyLong(dateString) {
  if (!dateString) return '';

  const date = parseDateOnly(dateString);
  if (!date) return formatDateLong(dateString);

  return date.toLocaleDateString('default', { day: 'numeric', month: 'long', year: 'numeric' });
}
